import z from 'zod'

export const ProviderAffiliationManageProvidersParams = z.object({
  affiliationId: z.coerce.number().int().positive(),
})
